import styled from 'styled-components';
import Button from '../Button';
import {
    primaryColorLight,
    primaryColor, outlineGray
} from '../../config/colors';

export const IdCardWrapper = styled.div`
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
  padding-bottom: 60px;
`;

export const TitleAndCommandsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export const TitlesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 25px;
  margin-left: 65px;
  margin-bottom: 30px;
  padding: 0;
  flex-grow: 1;
  flex-wrap: wrap;
  p:not(:last-of-type) {
    margin-bottom: 15px;
  }
`;

export const IdCardTitle = styled.h1`
  margin: 0px;
  margin-bottom: 15px;
  font-weight: 500;
  font-size: 1.8rem;
  display: inline-flex;
`;

export const ModuleTitle = styled.div`
  font-weight: 500;
  font-size: 1.25rem;
  display: inline-flex;
  margin-bottom: 12px;
`;

export const CommandsWrapper = styled.div`
  display: flex;
  padding: 4px;
  position: relative;
  position: relative;
  justify-content: end;
  position: sticky;
  flex-direction: column;
`;

export const TextualDetailsWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding-right: 30px;
`;

export const SectionTitle = styled(ModuleTitle)`
  margin-left: 15px;
  margin-bottom: 6px;
`;

export const SectionTitleEl = styled.div`
  display: inline-block;
  min-width: 380px;
`;

export const ImagesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 20px;
`;

export const ImageWrapper = styled.div`
  display: inline-flex;
  flex-direction: column;
  flex:1;
  margin-left: 20px;
`;

export const CharacteristicsAndModulesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 30px;
  margin-left: 10px;
`;

export const CharacteristicsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 3;
`;

export const CharacteristicsSectionWrapper = styled.div`
  margin-bottom: 20px;
`;

export const CharacteristicWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: 19px;
  margin-bottom: 3px;
  height: 44px;
  align-items: center;
`;

export const CharacteristicTitle = styled.div`
  flex: 2;
  color: ${primaryColorLight}
`;

export const CharacteristicUnit = styled.div`
  flex: 1;
  margin-left:3px;
`;

export const ModulesWrapper = styled.div`
  flex-direction: column;
  flex: 2;
`;

export const ModuleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 35px;
  cursor: pointer;
`;

export const ModuleImage = styled.div`
  flex: 1;
`;

export const ModuleNameWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex: 5;
  align-items: center;
  &:hover {
    color: ${primaryColor};
  }
`;

export const ModuleTsCode = styled.div`
  flex: 1;
`;

export const ModuleName = styled.div`
  flex: 4;
`;

export const SubMenusWrapper = styled.ul`
  display: flex;
  flex: 1;
  flex-direction: column;

  margin-top: 20px;
`;

export const SlotLoaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 50px;
`;

export const SaveChangesButton = styled(Button).attrs({
    wrapperStyle: {
        marginRight: '30px',
        width: '150px',
    },
    textStyle: {
        fontWeight: '600',
    },
})``;

export const DiscardChangesButton = styled(Button).attrs({
    wrapperStyle: {
        marginTop: '10px',
        width: '150px',
    },
    textStyle: {
        color: `${primaryColor}`,
        fontWeight: '600',
    },
})``;

export const DeleteIdCardButton = styled(Button).attrs({
    // TODO
    wrapperStyle: {
        marginTop: '28px',
        border: '1px dashed red',
        width: '150px',
    },
    textStyle: {
        color: 'red',
        fontWeight: '600',
    },
})``;

export const SaveChangesExitWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: space-between;
  padding-top: 20px;
`;

export const DescriptionAndMainImageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const DescriptionAndScopeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const CharacteristicInput = styled.input`
  width: 75%;
  height: 100%;
  padding: 10px 15px;
  box-sizing: border-box;
  border: 2px solid ${outlineGray};
  border-radius: 3px;
  padding: 5px 10px;
  font-size: 0.875rem;
`;
